import React from 'react';
import { useReleaseAnnouncement } from '../hooks/useReleaseAnnouncement';
import { ReleaseNotesDialog } from './ReleaseNotesDialog';
import { useAuth } from '../contexts/AuthContext';

export const ReleaseAnnouncementMount: React.FC = () => {
	const { user } = useAuth();
	const { shouldShow, version, changelogUrl, acknowledge } = useReleaseAnnouncement();
	// Only show for authenticated staff in business app; portal has its own app tree
	if (!user) return null;
	return (
		<ReleaseNotesDialog
			open={shouldShow}
			version={version}
			changelogUrl={changelogUrl}
			onAcknowledge={() => { void acknowledge(); }}
		/>
	);
}; 